/**
 * JSONData
 * Tem como função tratar os dados que vão caminhar entre o front e o backend em forma de JSON
 */
export class JSONData {
    get data() {
        return this._data;
    }
    set data(data) {
        this._data = data;
    }
    //Ao fazer nova instancia de JSONData, é necessário passar o json que o mesmo precisará tratar
    constructor(jsonData) {
        this._data = jsonData;
    }
    //Faz a construção do dado (no momento apenas retornando o objeto JSON)
    buildData() {
        return this.data;
    }
    //Constroi o caminho de retorno do dado para dentro da URL, sendo utilizado pelas requisições GET e DELETE do HTTP
    buildPathData() {
        let ret = "";
        for (let key in this._data) {
            ret += "\\" + this._data[key];
        }
        return ret;
    }
    //Cabeçalhos necessários quando se utilizar o JSON
    setHeader(httpHeaders) {
        httpHeaders.addHeader('Content-Type', 'application/json');
        return httpHeaders.buildHeader();
    }
}
